import React, { memo, useState, useEffect, useRef } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
// import { useSpring, animated } from 'react-spring'
import CountUp from 'react-countup';
import ServiceAdvantages from '../../components/ServiceAdvantages';
import DomesticSelection from '../../components/DomesticSelection';
import OverseasSelection from '../../components/OverseasSelection';
import PlanTravel from '../../components/PlanTravel';
import ServerGroup from '../../components/ServerGroup';
import VideoDisplay from '../../components/VideoDisplay';
import Morep from '../../components/Morep';
import { isMath, isNormalZhEnCss, getClientRect, delay } from '../../utils';

import styles from './styles.module.scss';

import backpacker from '../../assets/img/home/two/backpacker.jpg';
import hompagelastBg from '../../assets/img/home/hompagelastBg.jpg';

const Index = memo(() => {

    const dispatch = useDispatch();
    const { incrementCrossBorderPositioning } = actions;
    let navigate = useNavigate();


    const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
    const { home, lang } = useSelector(({localesReducer}) => localesReducer.i18n);
    const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);

    // 样式判断
    const normal = () => {
      if(recReSizeReducer > 1920){
        return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
      }

      if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
        return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
      }

      if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
        return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
      }

      if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
        return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
      }

      if(recReSizeReducer <= 750){
        return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
      }
    };


  const transitionFed = 'all 1.8s';
  const opacityStart = 0;
  const opacityEnd = 1;
  const translateYStart = `translateY(${isMath(recReSizeReducer, 300)})`;
  const translateYEnd = `translateY(${isMath(recReSizeReducer, 0)})`;
  const translateYOtherEnd = `translateY(${isMath(recReSizeReducer, 50)})`;
  const translateScaleStart = `scale(1.5)`;
  const translateScaleEnd = `scale(1)`;

  // 背景透明度 start
  const initFedOpacityStart = {
    opacity: opacityStart,
    transition: transitionFed,
  };
  // 背景透明度 end


  // 位移加透明度 start
  const initFedStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateYStart,
  };

  const initFedScaleStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateScaleStart,
  };
  // 位移加透明度 end

  // TODO: onePage start
  const oneAnimatedScreenRef = useRef(null);
  const [oneAnimatedScreenFlag, setOneAnimatedScreenFlag] = useState(true);
  const [oneAnimatedScreenStyle, setOneAnimatedScreenStyleApi] = useState(initFedScaleStart);
  const oneAnimatedScreenScroll = () => {
      if (oneAnimatedScreenFlag) {
        setOneAnimatedScreenStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateScaleStart,
        });
      }else{
        setOneAnimatedScreenStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateScaleEnd,
        });
      }
  }
  // TODO: onePage end


  // TODO: twoPage start
  const twoAnimatedH3TextRef = useRef(null);
  const twoAnimatedDescTextRef = useRef(null);
  const twoAnimatedBackpackerRef = useRef(null);
  const twoAnimatedMorepRef = useRef(null);


  const [twoAnimatedH3TextStyle, setTwoAnimatedH3TextStyleApi] = useState(initFedStart);
  const [twoAnimatedDescTextStyle, setTwoAnimatedDescTextStyleApi] = useState(initFedStart);
  const [twoAnimatedBackpackerStyle, setTwoAnimatedBackpackerStyleApi] = useState(initFedOpacityStart);
  const [twoAnimatedMorepStyle, setTwoAnimatedMorepApi] = useState(initFedStart);

  const twoAnimatedH3TexScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setTwoAnimatedH3TextStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });

        setTwoAnimatedBackpackerStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
        });
        
      }else{
        setTwoAnimatedH3TextStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });

        setTwoAnimatedBackpackerStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
        });
        
      }
  }

  const twoAnimatedDescTextScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setTwoAnimatedDescTextStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        setTwoAnimatedMorepApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setTwoAnimatedDescTextStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        setTwoAnimatedMorepApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }

  const twoAnimateScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          twoAnimatedH3TexScroll(twoAnimatedH3TextRef);
          twoAnimatedDescTextScroll(twoAnimatedDescTextRef);
      }else{
          // H5
          twoAnimatedH3TexScroll(twoAnimatedH3TextRef);
          twoAnimatedDescTextScroll(twoAnimatedDescTextRef);
      }
  }
  // TODO: twoPage end

  // TODO: threePage start
  const threeAnimatedLeftRef = useRef(null);
  const threeAnimatedRightRef = useRef(null);

  const [threeAnimatedLeftStyle, setThreeAnimatedLeftStyleleApi] = useState(initFedStart);
  const [threeAnimatedRightStylele, setThreeAnimatedRightStyleApi] = useState(initFedOpacityStart);

  const threeAnimatedLeftScroll = (curEle, num) => {
      let { isClientRect } = getClientRect(curEle, num); // 当前元素
      if (isClientRect) {
        setThreeAnimatedLeftStyleleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setThreeAnimatedLeftStyleleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }

  const threeAnimatedRightScroll = (curEle) => {
    let { isClientRect } = getClientRect(curEle, 900); // 当前元素
    if (isClientRect) {
      setThreeAnimatedRightStyleApi({
        opacity: opacityStart,
        transition: transitionFed,
      });
      
    }else{
      setThreeAnimatedRightStyleApi({
        opacity: opacityEnd,
        transition: transitionFed,
      });
      
    }
  }


    const threeAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            threeAnimatedLeftScroll(threeAnimatedLeftRef);
            threeAnimatedRightScroll(threeAnimatedRightRef);
        }else{
            // H5
            threeAnimatedLeftScroll(threeAnimatedLeftRef, 250);
            threeAnimatedRightScroll(threeAnimatedRightRef);
        }
    }
    // TODO: threePage end

    // TODO: fourPage start
    const fourAnimatedMorepRef = useRef(null);
    const fourAnimatedDSLeftRef = useRef(null);
    const fourAnimatedDSRightRef = useRef(null);

    const [fourAnimatedMorepStyle, setFourAnimatedMorepStyleleApi] = useState(initFedStart);
    const [fourAnimatedDSLeftStylele, setFourAnimatedDSLeftStyleleApi] = useState(initFedStart);
    const [fourAnimatedDSRightStylele, setFourAnimatedDSRightStyleleApi] = useState(initFedStart);

    const fourAnimatedMorepScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setFourAnimatedMorepStyleleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setFourAnimatedMorepStyleleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const fourAnimatedDSLeftScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setFourAnimatedDSLeftStyleleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setFourAnimatedDSLeftStyleleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const fourAnimatedDSRightScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle, 400); // 当前元素
      if (isClientRect) {
        setFourAnimatedDSRightStyleleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setFourAnimatedDSRightStyleleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }

    const fourAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            fourAnimatedMorepScroll(fourAnimatedMorepRef);
            fourAnimatedDSLeftScroll(fourAnimatedDSLeftRef);
            fourAnimatedDSRightScroll(fourAnimatedDSRightRef);
        }else{
            // H5
            fourAnimatedMorepScroll(fourAnimatedMorepRef);
            fourAnimatedDSLeftScroll(fourAnimatedDSLeftRef);
            fourAnimatedDSRightScroll(fourAnimatedDSRightRef);
        }
    }
    // TODO: fourPage end

    // TODO: fivesPage start
    const fivesAnimatedMorepRef = useRef(null);
    const fivesAnimatedOSRef = useRef(null);

    const [fivesAnimatedMorepStyle, setFivesAnimatedMorepStyleleApi] = useState(initFedStart);
    const [fivesAnimatedOSStyle, setFivesAnimatedOSStyleleApi] = useState(initFedStart);

    const fivesAnimatedMorepScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setFivesAnimatedMorepStyleleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setFivesAnimatedMorepStyleleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const fivesAnimatedOSScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle, 800); // 当前元素
        if (isClientRect) {
          setFivesAnimatedOSStyleleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setFivesAnimatedOSStyleleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const fivesAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            fivesAnimatedMorepScroll(fivesAnimatedMorepRef);
            fivesAnimatedOSScroll(fivesAnimatedOSRef);
        }else{
            // H5
            fivesAnimatedMorepScroll(fivesAnimatedMorepRef);
            fivesAnimatedOSScroll(fivesAnimatedOSRef);
        }
    }
    // TODO: fivesPage end

    // TODO: sixPage start
    const [totalFlag, setTotalFlag] = useState(false);
    const sixAnimatedStatisticsInnerRef = useRef(null);
    const sixAnimatedChooseRef = useRef(null);
    const sixAnimatedMorepRef = useRef(null);

    const [sixAnimatedStatisticsInnerStyle, setSixAnimatedStatisticsInnerStyleleApi] = useState(initFedStart);
    const [sixAnimatedChooseStyle, setSixAnimatedChooseStyleleApi] = useState(initFedStart);
    const [sixAnimatedMorepStyle, setSixAnimatedMorepStyleApi] = useState(initFedStart);

    const handleCountUp = (start, reset, pauseResume, current, flag, update, total) => {
      if(current){
        if(flag){
          update(total);
        }else{
          reset();
        }
      }
     
    }

    const sixAnimatedStatisticsInnerScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setSixAnimatedStatisticsInnerStyleleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          setTotalFlag(false);
          
        }else{
          setSixAnimatedStatisticsInnerStyleleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          setTotalFlag(true);
          
        }
    }

    const sixAnimatedChooseScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setSixAnimatedChooseStyleleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setSixAnimatedChooseStyleleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const sixAnimatedMorepScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setSixAnimatedMorepStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setSixAnimatedMorepStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const sixAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            sixAnimatedStatisticsInnerScroll(sixAnimatedStatisticsInnerRef);
            sixAnimatedChooseScroll(sixAnimatedChooseRef);
            sixAnimatedMorepScroll(sixAnimatedMorepRef);
        }else{
            // H5
            sixAnimatedStatisticsInnerScroll(sixAnimatedStatisticsInnerRef);
            sixAnimatedChooseScroll(sixAnimatedChooseRef);
            sixAnimatedMorepScroll(sixAnimatedMorepRef);
        }
    }
    // TODO: sixPage end

    // TODO: sevenPage start
    const sevenAnimatedServerGroupRef = useRef(null);

    const sevenAnimatedTitleRef = useRef(null);
    const sevenAnimatedDescRef = useRef(null);
    const sevenAnimatedChooseDestinatioRef = useRef(null);
    const sevenAnimatedSdLineRef = useRef(null);
    const sevenAnimatedGroupSelectCardRef = useRef(null);
    const sevenAnimatedGroupBtnRef = useRef(null);
    const sevenAnimatedBgRef = useRef(null);

    const [sevenAnimatedServerGroupStyle, setSevenAnimatedServerGroupStyleApi] = useState(initFedStart);

    const [sevenAnimatedTitleStyle, setSevenAnimatedTitleStyleApi] = useState(initFedStart);
    const [sevenAnimatedDescStyle, setSevenAnimatedDescStyleApi] = useState(initFedStart);
    const [sevenAnimatedChooseDestinatioStyle, setSevenAnimatedChooseDestinatioStyleApi] = useState(initFedStart);
    const [sevenAnimatedSdLineStyle, setSevenAnimatedSdLineStyleApi] = useState(initFedStart);
    const [sevenAnimatedGroupSelectCardStyle, setSevenAnimatedGroupSelectCardStyleApi] = useState(initFedStart);
    const [sevenAnimatedGroupBtnStyle, setSevenAnimatedGroupBtnStyleApi] = useState(initFedStart);
    const [sevenAnimatedBgStyle, sevenAnimatedBgStyleApi] = useState(initFedStart);

    const sevenAnimatedServerGrouScroll = (curEle, num) => {
        let { isClientRect } = getClientRect(curEle, num); // 当前元素
        if (isClientRect) {
          setSevenAnimatedServerGroupStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setSevenAnimatedServerGroupStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const sevenAnimatedTitleScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setSevenAnimatedTitleStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setSevenAnimatedTitleStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const sevenAnimatedDescScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setSevenAnimatedDescStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setSevenAnimatedDescStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
    }

    const sevenAnimatedChooseDestinatioScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setSevenAnimatedChooseDestinatioStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setSevenAnimatedChooseDestinatioStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
    }

    const sevenAnimatedSdLineScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setSevenAnimatedSdLineStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setSevenAnimatedSdLineStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
    }

    const sevenAnimatedGroupSelectCardScroll = (curEle, num) => {
      let { isClientRect } = getClientRect(curEle, num); // 当前元素
      if (isClientRect) {
        setSevenAnimatedGroupSelectCardStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setSevenAnimatedGroupSelectCardStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
    }

    const sevenAnimatedGroupBtnScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setSevenAnimatedGroupBtnStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setSevenAnimatedGroupBtnStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
    }

    const sevenAnimatedBgScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle, 400); // 当前元素
      if (isClientRect) {
        sevenAnimatedBgStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        sevenAnimatedBgStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYOtherEnd,
        });
        
      }
    }

    const sevenAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            sevenAnimatedServerGrouScroll(sevenAnimatedServerGroupRef);
            sevenAnimatedTitleScroll(sevenAnimatedTitleRef);
            sevenAnimatedDescScroll(sevenAnimatedDescRef);
            sevenAnimatedChooseDestinatioScroll(sevenAnimatedChooseDestinatioRef);
            sevenAnimatedSdLineScroll(sevenAnimatedSdLineRef);
            sevenAnimatedGroupSelectCardScroll(sevenAnimatedGroupSelectCardRef);
            sevenAnimatedGroupBtnScroll(sevenAnimatedGroupBtnRef);
            sevenAnimatedBgScroll(sevenAnimatedBgRef);
        }else{
            // H5
            sevenAnimatedServerGrouScroll(sevenAnimatedServerGroupRef, 700);
            sevenAnimatedTitleScroll(sevenAnimatedTitleRef);
            sevenAnimatedDescScroll(sevenAnimatedDescRef);
            sevenAnimatedChooseDestinatioScroll(sevenAnimatedChooseDestinatioRef);
            sevenAnimatedSdLineScroll(sevenAnimatedSdLineRef);
            sevenAnimatedGroupSelectCardScroll(sevenAnimatedGroupSelectCardRef, 600);
            sevenAnimatedGroupBtnScroll(sevenAnimatedGroupBtnRef);
            sevenAnimatedBgScroll(sevenAnimatedBgRef);
        }
    }
    // TODO: sevenPage end


    useEffect(() => {
      setOneAnimatedScreenFlag(false);
  
      delay(1000, () => {
        oneAnimatedScreenScroll();
      });
    }, [oneAnimatedScreenFlag]);


    useEffect(() => {
      twoAnimateScroll(); // twoPage
      threeAnimateScroll(); // threePage
      fourAnimateScroll(); // fourPage
      fivesAnimateScroll(); // fivesPage
      sixAnimateScroll(); // sixPage
      sevenAnimateScroll(); // sevenPage
    }, [scrolVal]);


    const desktopMobile = () => {
      const { twoPage, threePage, fourPage, fivesPage, sixPage } = home;

      const marginNum = recReSizeReducer <= 750 ? 0 : 100;
      const isAlignItems = recReSizeReducer <= 750 ? 'center' : 'baseline';
      return (
          <div className={normal()}>
            <div 
              className="onePage"
              ref={oneAnimatedScreenRef}
              style={oneAnimatedScreenStyle}
            >
              <VideoDisplay />
            </div>
            <div className="twoPage">
              <div className="content">
                <div className="intro">
                  <div ref={twoAnimatedBackpackerRef} style={twoAnimatedBackpackerStyle} className="backpacker"><img src={backpacker} alt=""/></div>
                  <div className="info">
                    <h3 ref={twoAnimatedH3TextRef} style={twoAnimatedH3TextStyle}><span>{twoPage.content.title}</span></h3>
                    <div ref={twoAnimatedDescTextRef} style={twoAnimatedDescTextStyle} className="desc">
                      <p><span>{twoPage.content.desc}</span></p>
                    </div>
                    <Morep
                        getRef={twoAnimatedMorepRef}
                        setStyle={twoAnimatedMorepStyle}
                        config={{
                          status: true, // 是否显示 icon
                          title: '',
                          path: '/aboutus', // 关于鼎盛
                          style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: isAlignItems,
                          },
                          iconCss: {
                            margin: '0 0 0 0',
                          }
                        }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="threePage" ref={threeAnimatedRightRef}>
              {/*动画区*/}
              <ServiceAdvantages
                config={{
                  getRefs: {
                    leftRef: threeAnimatedLeftRef,
                    leftStyles: threeAnimatedLeftStyle,
                    rightStyles: threeAnimatedRightStylele
                  },
                  data: threePage.serviceAdvantagesData,
                }}
              />
            </div>
            <div className="fourPage">
              <div className="headerTopContent" ref={fourAnimatedMorepRef} style={fourAnimatedMorepStyle}>
                <Morep
                    handleEvent={() => {
                      dispatch(incrementCrossBorderPositioning({crossBorderName: 'domestiTour'}))
                    }}
                    config={{
                      status: true, // 是否显示 icon
                      title: fourPage.morepTitle,
                      path: '/travelmall', // 旅行商城
                      style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: isAlignItems,
                      },
                      iconCss: {
                        margin: `0 0 0 ${isMath(recReSizeReducer, marginNum)}`,
                      }
                    }}
                />
              </div>
              {/*动画区*/}
              <DomesticSelection
                config={{
                  getRefs: {
                    leftRef: fourAnimatedDSLeftRef,
                    rightRef: fourAnimatedDSRightRef,
                    leftStyles: fourAnimatedDSLeftStylele,
                    rightStyles: fourAnimatedDSRightStylele,
                  },
                  data: fourPage.domesticSelectionData
                }}
              />
            </div>

            <div className="fivesPage">
              <div className="headerTopContent" ref={fivesAnimatedMorepRef} style={fivesAnimatedMorepStyle}>
                <Morep
                    handleEvent={() => {
                      dispatch(incrementCrossBorderPositioning({crossBorderName: 'overseasTour'}))
                    }}
                    config={{
                      status: true, // 是否显示 icon
                      title: fivesPage.morepTitle,
                      path: '/travelmall', // 旅行商城
                      style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: isAlignItems,
                      },
                      iconCss: {
                        margin: `0 0 0 ${isMath(recReSizeReducer, marginNum)}`,
                      }
                    }}
                />

              </div>
              {/*动画区*/}
              <OverseasSelection
                 handleEvent={() => {
                  dispatch(incrementCrossBorderPositioning({crossBorderName: 'overseasTour'}))
                  navigate('/travelmall');
                 }}
                 config={{
                  getRefs: {
                    innerRef: fivesAnimatedOSRef,
                    innerStyles: fivesAnimatedOSStyle,
                  },
                  data: fivesPage.overseasSelectionData
                }}
              />
            </div>

            <div className="sixPage">
              <div className="statistics">
                <div className="statisticsInner" ref={sixAnimatedStatisticsInnerRef} style={sixAnimatedStatisticsInnerStyle}>
                  <div className="since"><span>{sixPage.statisticsInner.since}</span></div>
                  {/* <div className="total"><span>{sixPage.statisticsInner.total}</span></div> */}
                  <CountUp
                    start={0.00}
                    end={Number(sixPage.statisticsInner.total.replace(',', ''))}
                    duration={5}
                    separator=","
                    // decimals={3}
                    decimal=","
                    delay={2}
                  >
                    {({ countUpRef, start, reset, pauseResume, update}) => {
                      let total = Number(sixPage.statisticsInner.total.replace(',', ''));
                      handleCountUp(start, reset, pauseResume, countUpRef.current, totalFlag, update, total);
                      return (<div className="total"><span ref={countUpRef} /></div>);
                    }}
                  </CountUp>
                  <div className="customers"><span>{sixPage.statisticsInner.customers}</span></div>
                </div>
                <div className="choose" ref={sixAnimatedChooseRef} style={sixAnimatedChooseStyle}><span>{sixPage.choose}</span></div>
                <div className="seeMoreInfo" ref={sixAnimatedMorepRef} style={sixAnimatedMorepStyle}>
                  <Morep
                      config={{
                        status: true, // 是否显示 icon
                        path: '/aboutus', // 关于鼎盛
                        style: {
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'flex-start',
                          alignItems: isAlignItems,
                        },
                        iconCss: {
                          margin: '0 0 0 0',
                        }
                      }}
                  />
                </div>
              </div>
            </div>

            <div className="sevenPage">
              <div className="content">
                  <ServerGroup
                    config={{
                      getRefs: {
                        innerRef: sevenAnimatedServerGroupRef,
                        innerStyles: sevenAnimatedServerGroupStyle,
                      },
                    }}
                  />
                  <PlanTravel
                    config={{
                      getRefs: {
                        innerTitleRef: sevenAnimatedTitleRef,
                        innerDescRef: sevenAnimatedDescRef,
                        innerChooseDestinatioRef: sevenAnimatedChooseDestinatioRef,
                        innerSdLineRef: sevenAnimatedSdLineRef,
                        innerGroupSelectCardRef: sevenAnimatedGroupSelectCardRef,
                        innerGroupBtnRef: sevenAnimatedGroupBtnRef,
                        innerTitleStyles: sevenAnimatedTitleStyle,
                        innerDescStyles: sevenAnimatedDescStyle,
                        innerChooseDestinatioStyles: sevenAnimatedChooseDestinatioStyle,
                        innerChooseSdLineStyles: sevenAnimatedSdLineStyle,
                        innerGroupSelectCardStyles: sevenAnimatedGroupSelectCardStyle,
                        innerGroupBtnStyles: sevenAnimatedGroupBtnStyle,
                      },
                      status: 1,
                    }}
                  />
              </div>
             <div className="innerBg" ref={sevenAnimatedBgRef} style={{...sevenAnimatedBgStyle, zIndex: 0}}>
               <img src={hompagelastBg} alt='' />
             </div>
              
            </div>
          </div>
      );
    };

    return desktopMobile();
});
export default Index;
